'use strict';
module.exports = require('./MultiSelect.vue');